// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCTMVAmLQi08X6YSVelIERIkm8z9GlWM60",               // from Google Cloud
  authDomain: "psychic-torus-241914.firebaseapp.com",
  projectId: "psychic-torus-241914",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
